import {createRouter, createWebHashHistory} from 'vue-router'

const router = createRouter({
    history: createWebHashHistory(),  // history 模式
    routes: [
        {
            path: '/',
            name: 'login',
            component: (() => import((`../view/login/LoginPage.vue`))),
            meta: {
                title: '建景电子商务',
            }
        },
        {
            path: '/home',
            name: 'home',
            component: (() => import((`../view/home/HomePage.vue`))),
            meta: {
                title: '首页',
            },
            children: [
                {
                    path: '/home/system/user',
                    name: 'user',
                    component: (() => import((`../view/user/UserPage.vue`))),
                    meta: {
                        title: '用户管理',
                    }
                },
                {
                    path: '/home/play/luckybag',
                    name: 'lucky_bag',
                    component: (() => import((`../view/play/luckybag/LuckyBagPage.vue`))),
                    meta: {
                        title: '福袋',
                    }
                },
                {
                    path: '/home/play/luckybag/info',
                    name: 'lucky_bag-info',
                    component: (() => import((`../view/play/luckybag/info/InfoPage.vue`))),
                    meta: {
                        title: '福袋明细',
                    }
                },
                {
                    path: '/home/play/blindbox',
                    name: 'blind_box',
                    component: (() => import((`../view/play/blindbox/BlindBoxPage.vue`))),
                    meta: {
                        title: '盲盒',
                    }
                },
                {
                    path: '/home/play/blindbox/info',
                    name: 'blind_box-info',
                    component: (() => import((`../view/play/blindbox/info/InfoPage.vue`))),
                    meta: {
                        title: '盲盒明细',
                    }
                },
                {
                    path: '/home/play/gacha',
                    name: 'gacha',
                    component: (() => import((`../view/play/gacha/GachaPage.vue`))),
                    meta: {
                        title: '抽卡机',
                    }
                },
                {
                    path: '/home/play/gacha/info',
                    name: 'gacha-info',
                    component: (() => import((`../view/play/gacha/info/InfoPage.vue`))),
                    meta: {
                        title: '抽卡机明细',
                    }
                },
                {
                    path: '/home/play/team',
                    name: 'team',
                    component: (() => import((`../view/play/team/TeamPage.vue`))),
                    meta: {
                        title: '拼团',
                    }
                },
                {
                    path: '/home/play/team/info',
                    name: 'team-info',
                    component: (() => import((`../view/play/team/info/InfoPage.vue`))),
                    meta: {
                        title: '拼团明细',
                    }
                },
                {
                    path: '/home/play/onereward',
                    name: 'one_reward',
                    component: (() => import((`../view/play/onereward/OneRewardPage.vue`))),
                    meta: {
                        title: '一番赏',
                    }
                },
                {
                    path: '/home/play/onereward/info',
                    name: 'one_reward-info',
                    component: (() => import((`../view/play/onereward/info/InfoPage.vue`))),
                    meta: {
                        title: '一番赏明细',
                    }
                },
                {
                    path: '/home/play/good',
                    name: 'good',
                    component: (() => import((`../view/play/good/GoodPage.vue`))),
                    meta: {
                        title: '商城',
                    }
                },
                {
                    path: '/home/play/prize',
                    name: 'prize',
                    component: (() => import((`../view/play/prize/PrizePage.vue`))),
                    meta: {
                        title: '抽奖',
                    }
                },
                {
                    path: '/home/play/prize/info',
                    name: 'prize-info',
                    component: (() => import((`../view/play/prize/info/InfoPage.vue`))),
                    meta: {
                        title: '抽奖明细',
                    }
                },
                {
                    path: '/home/main/notice',
                    name: 'notice',
                    component: (() => import((`../view/notice/NoticePage.vue`))),
                    meta: {
                        title: '消息通知',
                    }
                },
                {
                    path: '/home/main/history',
                    name: 'history',
                    component: (() => import((`../view/point/PointPage.vue`))),
                    meta: {
                        title: '消费记录',
                    }
                },
                {
                    path: '/home/main/order',
                    name: 'order',
                    component: (() => import((`../view/order/OrderPage.vue`))),
                    meta: {
                        title: '订单管理',
                    }
                },
                {
                    path: '/home/main/carousel',
                    name: 'carousel',
                    component: (() => import((`../view/carousel/CarouselPage.vue`))),
                    meta: {
                        title: '首页管理',
                    }
                },
                {
                    path: '/home/play/fighting',
                    name: 'fighting',
                    component: (() => import((`../view/play/fighting/FightingPage.vue`))),
                    meta: {
                        title: '打拳设置',
                    }
                },
                {
                    path: '/home/play/fighting/info',
                    name: 'fighting-info',
                    component: (() => import((`../view/play/fighting/info/InfoPage.vue`))),
                    meta: {
                        title: '打拳明细',
                    }
                },
                {
                    path: '/home/play/toy',
                    name: 'toy',
                    component: (() => import((`../view/play/toy/ToyPage.vue`))),
                    meta: {
                        title: '手办设置',
                    }
                },
                {
                    path: '/home/main/card',
                    name: 'card',
                    component: (() => import((`../view/card/CardPage.vue`))),
                    meta: {
                        title: '卡集',
                    }
                },
                {
                    path: '/home/play/toy/info',
                    name: 'toy-info',
                    component: (() => import((`../view/play/toy/info/InfoPage.vue`))),
                    meta: {
                        title: '手办明细',
                    }
                }
            ]
        }
    ]
})

// 全局路由守卫
router.beforeEach((to, from, next)=>{
    if (to.meta.title) {
        document.title = `${to.meta.title}`;
    } else {
        document.title = `未知名称`;
    }
    next()
})

export default router
